type CSWindow = Window & {
  __csInitialized?: boolean
}

function isTruthy(v: unknown): boolean {
  return (
    String(v || '')
      .toLowerCase()
      .trim() === 'true'
  )
}

function isLocalhostHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0' || hostname === ''
}

export function initContentsquare(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  const tagId = String(import.meta.env.VITE_CONTENTSQUARE_TAG_ID || '').trim()
  if (!tagId) return

  const enableInDev = isTruthy(import.meta.env.VITE_CONTENTSQUARE_ENABLE_IN_DEV)
  const hostname = window.location.hostname
  const isLocalhost = isLocalhostHostname(hostname)
  if ((import.meta.env.DEV || isLocalhost) && !enableInDev) return

  const w = window as CSWindow
  if (w.__csInitialized) return
  w.__csInitialized = true

  const head = document.getElementsByTagName('head')[0]
  if (!head) return

  const existing = document.querySelector(`script[src="https://t.contentsquare.net/uxa/${tagId}.js"]`)
  if (existing) return

  const s = document.createElement('script')
  s.async = true
  s.src = `https://t.contentsquare.net/uxa/${encodeURIComponent(tagId)}.js`
  head.appendChild(s)
}
